<template>
  <div class="teamDepartment">
    <div class="teamDepartmentTop">
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
        <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
        <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
        <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
        <el-tab-pane label="定时任务补偿1" name="fourth1">定时任务补偿1</el-tab-pane>
        <el-tab-pane label="定时任务补偿2" name="fourth2">定时任务补偿2</el-tab-pane>
        <el-tab-pane label="定时任务补偿3" name="fourth3">定时任务补偿3</el-tab-pane>
        <el-tab-pane label="定时任务补偿4" name="fourth4">定时任务补偿4</el-tab-pane>
        <el-tab-pane label="定时任务补偿5" name="fourth5">定时任务补偿5</el-tab-pane>
        <el-tab-pane label="定时任务补偿6" name="fourth6">定时任务补偿6</el-tab-pane>
        <el-tab-pane label="定时任务补偿7" name="fourth7">定时任务补偿7</el-tab-pane>
      </el-tabs> -->
      <el-select v-if="teamType == 1" v-model="listId" placeholder="请选择" style="width: 100%;" @change="handleHd01">
        <el-option
          v-for="item in hdList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <ul v-if="teamType !== 1" class="teamDepartmentTopList" :class="{teamDepartmentTopList01: teamType == 1, teamDepartmentTopList02: teamType == 2, teamDepartmentTopList03: teamType == 3}">
        <li
          v-for="(item, index) in hdList"
          :key="index"
          :class="{ active: active == index }"
          @click="handleHd(item, index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <ul class="teamDepartmentList clearfloat">
      <li v-for="(item, index) in list" :key="index">
        <router-link :to="'/contentTeam?id=' + item.id" target="_blank">
          <div class="teamDepartmentPic">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.img"
              fit="cover"
            >
            </el-image>
          </div>
          <div class="teamDepartmentInner">
            <div class="teamDepartmentHd">{{ item.name }}</div>
            <div class="teamDepartmentPost single-line">{{ item.position }}</div>
            <div class="teamDepartmentCont multi-line">{{ setText(item.info) }}</div>
          </div>
        </router-link>
      </li>
    </ul>

    <div class="teamLeaderPage">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="12"
        :current-page="pageNum"
        @current-change="handleCurrent"
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      typeof: [Number, String, Boolean],
      default: null
    }
  },
  data() {
    return {
      valueTeamHd: null,
      teamType: null,
      listId: null,
      pageNum: 1,
      total: 0,
      active: 0,
      hdList: [
        // {
        //   name: "党委办公室、党委组织部",
        //   id: ""
        // },
        // {
        //   title: "办公室",
        //   id: ""
        // },
        // {
        //   title: "人力资源部",
        //   id: ""
        // },
        // {
        //   title: "财务资产管理部",
        //   id: ""
        // },
        // {
        //   title: "市场开发部",
        //   id: ""
        // },
        // {
        //   title: "质量安全部",
        //   id: ""
        // },
      ],
      activeName: 'second',
      list: [
        // {
        //   title: "张某某",
        //   img: require("@/assets/img/team/memories_b1.jpg"),
        //   post: "董事长、执行董事长",
        //   content: "张某某张某某张某某张某某，张某某张某某张某某张某某，张某某张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某张某某张某某张某某张某某张某某，张某某张某某张某某"
        // },
      ]
    };
  },
  mounted() {
    var _this = this

    if (_this.groupId == 7) {
      _this.teamType = 1
    } else if (_this.groupId == 8) {
      _this.teamType = 2
    } else if (_this.groupId == 9) {
      _this.teamType = 3
    }
    _this.getSeverNavSub(_this.groupId)
    // _this.getList(_this.groupId)
  },
  methods: {
    handleCurrent(val) {
      var _this = this

      _this.pageNum = val
      _this.getList()
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleHd01(val) {
      var _this = this
      _this.listId = val
      _this.pageNum = 1
      this.getList()
    },
    handleHd(item, index) {
      var _this = this
      this.active = index
      _this.pageNum = 1
      _this.listId = item.id
      this.getList()
    },
    async getSeverNavSub(id){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamTypeList2',{id: id});
      if(data.code == 200){
        _this.hdList = data.data
        _this.listId = data.data[0].id
        data.data.length && _this.getList()
      }
    },
    async getList(){
      var _this = this
      _this.list = []
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamInfoList',{classification: _this.listId, page: _this.pageNum});
      if(data.code == 200){
        _this.list = data.data.list
        _this.total = data.data.total
      }
    },
    // 提取纯文本
    setText(val) {
      if (val != null && val != "") {
        var re1 = new RegExp("<.+?>|&.+?;","g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
        var msg = val.replace(re1,""); //执行替换成空字符
        msg = msg.replace(/\s/g,""); //去掉所有的空格（中文空格、英文空格都会被替换）
        msg = msg.replace(/[\r\n]/g,""); //去掉所有的换行符
        return msg.substr(0, 100); //获取文本文字内容的前100个字符
        // return msg;
      } else return ""
    },
  }
};
</script>

<style>
.teamDepartment {
  margin-top: 15px;
}
.teamDepartmentTopList {
  text-align: center;
}
.teamDepartmentTopList li {
  display: inline-block;
  height: 42px;
  line-height: 42px;
  padding: 0 15px;
  font-size: 14px;
  /* border: 1px solid #e5e5e5; */
  margin: 0 4px 10px;
  cursor: pointer;
  color: #555;
  background-color: #f1f1f1;
  border-radius: 2px;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.teamDepartmentTopList li:hover {
  color: #fff;
  background-color: #337cbb;
}
.teamDepartmentTopList li.active {
  color: #fff;
  background-color: #e62129;
}
.teamDepartmentTopList01 li {
  white-space: nowrap;
  overflow: hidden;
  width: 171px;
  padding: 0 4px;
}
.teamDepartmentTopList02 li {
  width: 400px;
}
.teamDepartmentTopList03 li {
  width: 150px;
}
.teamDepartmentList {
  margin-top: 15px;
}
.teamDepartmentList li {
  float: left;
  width: 15.66%;
  margin: 0 0.5% 15px;
  font-size: 12px;
  line-height: 20px;
}
.teamDepartmentList li a {
  display: block;
  color: #555;
  background-color: #f9f9f9;
  position: relative;
  top: 0;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.teamDepartmentList li a:hover {
  top: -6px;
  background-color: #fff;
  /* box-shadow: 0 2px 1px 10px 1px; */
  box-shadow: 0 4px 10px 1px #ccc;
}
.teamDepartmentPic {
  height: 190px;
}
.teamDepartmentInner {
  padding: 6px 6px;
  height: 84px;
}
.teamDepartmentHd {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.teamDepartmentPost {
  margin-top: 6px;
}
.teamDepartmentCont {
  margin-top: 6px;
  line-height: 20px;
  min-height: 40px !important;
}
.teamLeaderPage {
  text-align: center;
  margin: 40px 0;
}
</style>
